import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-error-card',
  templateUrl: './error-card.component.html',
  styleUrls: ['./error-card.component.scss']
})
export class ErrorCardComponent {
  @Input() title?: string;
  @Input() reason?: string;
  @Input() errorFooter?: string;
  @Input() details?: string;
  @Input() banner: boolean = false; // true => bannière simple, sans action
  @Input() businessContact?: string;
  @Input() clientCode?: string;
  @Input() errorType?: 'no-order' | 'catalog' | 'generic';

  @Output() retry = new EventEmitter<void>();

  public onRetry(): void {
    this.retry.emit();
  }

  public get mailtoHref(): string {
    const to = this.businessContact || '';
    const client = this.clientCode || '';
    const subject = `Demande assistance - client ${client || 'N/A'}`;

    const parts: string[] = [];
    if (this.errorType === 'no-order') parts.push('Contexte : aucune commande sélectionnée/créée.');
    if (this.errorType === 'catalog') parts.push('Contexte : erreur de chargement des catalogues.');
    if (this.reason) parts.push('Raison : ' + this.stripHtml(this.reason));
    if (this.details) parts.push('Détails : ' + this.stripHtml(this.details));

    parts.push('URL : ' + window.location.href);
    parts.push('Date : ' + new Date().toLocaleString());

    const body = parts.join('\n\n');
    return `mailto:${encodeURIComponent(to)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }

  private stripHtml(text?: string): string {
    return text ? text.replace(/<br\s*\/?>/gi, '\n').replace(/<[^>]*>/g, '') : '';
  }
}